import { defineMessages } from 'react-intl';

export default defineMessages({
  subscribe: {
    id: 'widget.channel-actions.subscribe',
    defaultMessage: 'Subscribe {price}/month',
  },
});



// WEBPACK FOOTER //
// ./src/widget/components/channel-actions/translations.js